import React, { useState, useEffect } from 'react';
import { X, Shield, Clock, User, CheckCircle2, AlertCircle } from 'lucide-react';
import { getArticleAuditLogs } from '../../../services/newsNewsletterApi';

export default function AuditLogsModal({ isOpen, onClose, article }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && article?._id) {
      loadLogs();
    }
  }, [isOpen, article]);

  const loadLogs = async () => {
    setLoading(true);
    try {
      const res = await getArticleAuditLogs(article._id);
      if (res?.success) {
        setLogs(res.data || []);
      }
    } catch (err) {
      console.error('Erreur audit logs:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !article) return null;

  const formatDate = (d) => {
    if (!d) return '-';
    return new Date(d).toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getActionBadge = (action) => {
    const map = {
      ARTICLE_CREATED: { label: 'Création', class: 'info' },
      ARTICLE_UPDATED: { label: 'Modification', class: 'primary' },
      ARTICLE_APPROVED: { label: 'Approbation', class: 'success' },
      ARTICLE_REJECTED: { label: 'Rejet', class: 'danger' },
      ARTICLE_PUBLISHED: { label: 'Publication', class: 'success' },
      ARTICLE_UNPUBLISHED: { label: 'Dépublication', class: 'warning' },
      ARTICLE_ARCHIVED: { label: 'Archivage', class: 'secondary' },
      ARTICLE_SOFT_DELETED: { label: 'Suppression logique', class: 'danger' },
      ARTICLE_RESTORED: { label: 'Restauration', class: 'info' },
    };
    const conf = map[action] || { label: action, class: 'neutral' };
    return <span className={`an-badge an-badge-${conf.class}`}>{conf.label}</span>;
  };

  return (
    <div className="an-modal-backdrop animate-fade-in" onClick={onClose}>
      <div className="an-modal-card an-modal-medium" onClick={(e) => e.stopPropagation()}>
        <div className="an-modal-header">
          <div className="an-modal-title">
            <Shield size={22} className="text-primary mr-2" />
            <span>Journal d'Audit Immuable</span>
          </div>
          <button className="an-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="an-modal-body">
          <div className="an-audit-target-summary">
            <strong>{article.title}</strong>
            <span className="an-audit-code">{article.articleCode || article._id}</span>
          </div>

          {loading ? (
            <div className="an-loading-state">Chargement de la piste d'audit...</div>
          ) : logs.length === 0 ? (
            <div className="an-empty-state">Aucun enregistrement d'audit pour cet article.</div>
          ) : (
            <div className="an-timeline">
              {logs.map((log) => (
                <div key={log._id} className="an-timeline-item">
                  <div className="an-timeline-marker" />
                  <div className="an-timeline-content">
                    <div className="an-timeline-header">
                      {getActionBadge(log.action)}
                      <span className="an-timeline-date">
                        <Clock size={13} className="mr-1" />
                        {formatDate(log.createdAt)}
                      </span>
                    </div>

                    <div className="an-timeline-user">
                      <User size={13} className="mr-1 text-muted" />
                      <span>{log.performedByName || log.performedByEmail || 'Système'}</span>
                      {log.performedByRole && (
                        <span className="an-user-role-badge">({log.performedByRole})</span>
                      )}
                    </div>

                    {log.details && (
                      <div className="an-timeline-details">
                        {log.details.rejectionReason && (
                          <div className="text-danger font-medium">
                            Motif du rejet : "{log.details.rejectionReason}"
                          </div>
                        )}
                        {log.details.changes && Object.keys(log.details.changes).length > 0 && (
                          <div className="an-changes-list">
                            Champs modifiés : {Object.keys(log.details.changes).join(', ')}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="an-modal-footer">
          <button type="button" className="an-btn-secondary" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}

